import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[toLowerCase]',
})
export class LowercaseDirective {
  @HostListener('input', ['$event']) onInput(event: Event) {
    let input = event.target as HTMLInputElement;
    input.value = input.value.toLowerCase();
    this.control.control?.setValue(input.value);
  }

  @HostListener('blur', ['$event']) onBlur(event: Event) {
    let input = event.target as HTMLInputElement;
    input.value = input.value.toLowerCase();
    this.control.control?.setValue(input.value);
  }

  constructor(private control:NgControl) {
  }

}

